import Navigation from "./components/navigation";
import Footer from "./components/footer";
import { companyName, navigation } from "./config/constants";
import TightMain from "./pkg/components/tight-main";
import HeadingTitle from "./pkg/components/heading-title";
import SubHeadingTitle from "./pkg/components/sub-heading-title";
import Paragraph from "./pkg/components/paragraph";
import Link from "./pkg/components/link";

function About() {
    return (
        <>
            <Navigation companyName={companyName} navigation={navigation} />

            <TightMain>

                <HeadingTitle>Protoku BV</HeadingTitle>

                <SubHeadingTitle>Address</SubHeadingTitle>

                <Paragraph>
                    Protoku BV<br />
                    Walter Thijsstraat 7<br />
                    3500 Hasselt<br />
                    Belgium
                </Paragraph>


                <SubHeadingTitle>Legal Information</SubHeadingTitle>

                <Paragraph>
                    Company number: 686.633.603<br />
                    VAT number: BE0686633603<br />
                    IBAN: BE66 1030 5301 7743<br />
                    BIC: NICA BE BB
                </Paragraph>


                <SubHeadingTitle>Email</SubHeadingTitle>

                <Paragraph>
                    <Link href={"mailto:hello@protoku.be"}>hello@protoku.be</Link>
                </Paragraph>

            </TightMain>

            <Footer />
        </>
    );
}

export default About;
